import httpClient  from '.';

export default {
    //Mã hút dòng tiền nhất
    async getSecMostInflow() {
        let url = '/pbapi/api/secMostInflow';
        return await httpClient.get(url);
    },

    //Ngành hút dòng tiền nhất
    async getIndMostInflow() {
        let url = '/pbapi/api/Industry/indMostInflow';
        return await httpClient.get(url);
    },

    //Điển index
    async getIndex(index) {
        let url = 'pbapi/api/stockBoard/index/' + index;
        return await httpClient.get(url);
    },

    //Mascot 
    async getMascot() {
        let url = '/pbapi/api/admin/ImageUpload';
        return await httpClient.get(url);
    },
}